<template>
  <a-tooltip :title="disabled ? 'Solo puede existir un elemento de este tipo' : null">
    <div class="card" :class="{ selected: selected, disabled: disabled }" @click="handleSelect">
      <h4>
        <img :src="getElementIcon(element.type)" :alt="`${element.type}-icon`" />

        {{ element.name }}
      </h4>
      <p>{{ element.description }}</p>
    </div>
  </a-tooltip>
</template>

<script setup lang="ts">
import type { ElementType, FormElementOption } from "@/@types/entities/forms";

const props = defineProps<{
  element: FormElementOption;
  selected: boolean;
  disabled: boolean;
}>();

const emit = defineEmits<{
  (e: "select", element: FormElementOption): void;
}>();

const getElementIcon = (type: ElementType) => {
  return new URL(`../../assets/formTypes/${type}.svg`, import.meta.url).href;
};

const handleSelect = () => {
  if (props.disabled) return;

  emit("select", props.element);
};
</script>

<style scoped lang="sass">
h4, p
  margin: 0
  color: $gray-9
  font-size: 14px
  font-weight: 400

h4
  display: flex
  align-items: center
  gap: 4px

  img
    height: 18px
    width: 18px

p
  text-align: center
  margin: 0 20px
  color: $gray-8
  font-size: 12px

.card
  height: 100px
  border: 1px solid $gray-5
  border-radius: 8px
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1)
  display: flex
  flex-direction: column
  gap: 5px
  align-items: center
  justify-content: center
  cursor: pointer
  user-select: none

  &:hover
    border-color: $blue-5

  &.selected
    border-color: $blue-5

  &.disabled
    cursor: not-allowed
    opacity: 0.5
    box-shadow: none
    background-color: $gray-3
    color: $gray-6

    &:hover
      border-color: $gray-5
</style>
